import React, { useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import { getPatient } from "../../store/actions/patients_action";
import Spinner from "../../components/layout/Spinner";
import {
  inputFields,
  PAGE_TITLE,
  PAGE_SINGLE_TITLE,
  LINK_URL,
} from "../../shared/enums/patients_enum";
import SingleView from "../../components/common/SingleView";
const ViewPatient = ({ getPatient, match, patient: { loading, patient } }) => {
  useEffect(() => {
    getPatient(match.params.id);
  }, [match]);
  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title={PAGE_SINGLE_TITLE}
          mainLinkTitle={PAGE_TITLE}
          mainLinkUrl={LINK_URL}
          activeLink="View"
        />
        {!loading ? (
          patient && (
            <SingleView
              data={patient}
              inputFields={inputFields}
              label={PAGE_SINGLE_TITLE}
              link={LINK_URL}
              id={patient.id}
              hideGallery={true}
            />
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ patient: state.patient });

const mapDispatchToProps = { getPatient };

export default connect(mapStateToProps, mapDispatchToProps)(ViewPatient);
